<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="18" height="12" viewBox="0 0 22 12" fill="none">                
    <path d="M19 1H2C1.44772 1 1 1.44772 1 2V10C1 10.5523 1.44771 11 2 11H19C19.5523 11 20 10.5523 20 10V2C20 1.44772 19.5523 1 19 1Z" stroke="#333333" stroke-width="1.25"/>
    <path d="M18 3H3V9H18V3Z" fill="#333333" stroke="#333333" stroke-width="1.25"/>
    <path d="M20 4.5V7.5C20 7.77614 20.2239 8 20.5 8C20.7761 8 21 7.77614 21 7.5V4.5C21 4.22386 20.7761 4 20.5 4C20.2239 4 20 4.22386 20 4.5Z" stroke="#333333" stroke-width="1.25"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
